import React, { useContext, useState } from "react";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { Context } from "../../../context/context";

import "./CsvPage.scss";
import { Button } from "@mui/material";
import { CSVLink } from "react-csv";
import { getCoveps } from "../../../services/covep-service";
import moment from "moment";
import formattedValues from "../../../utils/format-covep";

const todayDate = new Date();

export default function CsvPage() {
  const { sidebar } = useContext(Context);
  const accessToken = localStorage.getItem("token");
  const [dateValue, setDateValue] = useState([
    moment(todayDate).subtract(30, "day").toDate(),
    new Date(),
  ]);
  const [covepResults, setCovepResults] = useState([]);
  const [isCsvAllowed, setIsCsvAllowed] = useState(false);

  async function getCovepsByDate() {
    try {
      const result = await getCoveps(
        accessToken,
        moment(dateValue[0]).format("YYYY-MM-DD"),
        moment(dateValue[1]).format("YYYY-MM-DD")
      );

      if (!result.length) return alert("Não foi encontrado nenhum resultado.");

      setCovepResults(formattedValues(result));
      setIsCsvAllowed(true);
    } catch (error) {
      alert("Algo deu errado. Tente novamente mais tarde.");
    }
  }

  return (
    <main className={sidebar ? "container" : "container-full"}>
      <h1>CSV</h1>

      <div className="csv-container">
        <p>Favor escolher uma data para gerar o csv</p>

        {/* <div className="form-container">
          <SelectInput
            value={competitors}
            name="Filtrar por concorrente"
            setValue={setCompetitors}
            selectValues={selectValues.competitors}
          />
        </div> */}
        <DateRangePicker onChange={(e) => setDateValue(e)} value={dateValue} />
      </div>

      <Button
        size="medium"
        onClick={() => getCovepsByDate()}
        style={{ width: "265px", marginTop: "0" }}
        variant="contained"
        className="new-user"
      >
        Gerar CSV
      </Button>

      {isCsvAllowed && (
        <div className="csv-link">
          <CSVLink
            filename={`planilha-coveps-${moment(todayDate).format(
              "YYYY-MM-DD"
            )}`}
            data={covepResults}
            target="_blank"
          >
            Baixar CSV
          </CSVLink>
        </div>
      )}

      {/* <LineChart /> */}
    </main>
  );
}
